
module.exports =  require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/engine.io-client/index.js
 ** module id = 631
 ** module chunks = 2
 **/